<template>
  <div id="app" v-if="pageShow">
    <router-view></router-view>
    <!-- <van-actionsheet v-model="tools.show" :actions="tools.actions" @select="doChangeServer"/> -->
  </div>
</template>

<script>
import { wechatAuth } from "@/utils/wechat";
import { browser } from "@/utils";
export default {
  data() {
    return {
      pageShow: false
    };
  },
  methods: {},

  // },
  created() {
    if (!browser.wechat) {
      this.pageShow = true;
    } else {
      wechatAuth(() => {
        this.pageShow = true;
      });
    }
  }
};
</script>

<style>
</style>
